/**
 * Storage封装
 */
const STORAGE_KEY = 'zr-water'

/** 操作用户信息常量 */
export const TOKEN_INFO = 'tokenInfo'
/** 操作sidebar信息常量 */
export const SIDEBAR_STATUS = 'sidebarStatus'
/** 动态nav数据 */
export const Dynamic_System = 'dynamicSystem'
export const Permission_Routes = 'permissionRoutes'
export default {
  // 存储值
  setItem(key, value, moduleName) {
    if (moduleName) {
      const val = this.getItem(moduleName)
      val[key] = value
      this.setItem(moduleName, val)
    } else {
      const val = this.getStorage()
      val[key] = value
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(val))
    }
  },
  // 获取某一个模块下面的属性user下面的userName
  getItem(key, moduleName) {
    if (moduleName) {
      const val = this.getItem(moduleName)
      if (val) return val[key]
    }
    return this.getStorage()[key]
  },
  getStorage() {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}')
  },
  clearStorage(key, moduleName) {
    const val = this.getStorage()
    if (moduleName) {
      if (!val[moduleName]) return
      delete val[moduleName][key]
    } else {
      delete val[key]
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(val))
  }
}
